import { Button } from "@mui/material"
import { CounterButtonProps } from "../types";
import { getButtonStyles } from "../utils";

const CounterButton = ({ onClick, sx, disabled = false, children }: CounterButtonProps) => {
  return (
    <Button
      color="secondary" 
      variant="outlined"
      disableRipple
      disabled={disabled}
      onClick={onClick}
      sx={getButtonStyles(sx)}
    >
      {children}
    </Button>
  );
};

export default CounterButton;